import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a7a46c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "windows-10-loading" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"windows-10-loading__inner\" data-v-8a7a46c6><span class=\"windows-10-loading__dot\" data-v-8a7a46c6></span><span class=\"windows-10-loading__dot\" data-v-8a7a46c6></span><span class=\"windows-10-loading__dot\" data-v-8a7a46c6></span><span class=\"windows-10-loading__dot\" data-v-8a7a46c6></span><span class=\"windows-10-loading__dot\" data-v-8a7a46c6></span></div>", 1)
const _hoisted_3 = {
  key: 0,
  class: "windows-10-loading__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true)
  ]))
}